module.exports = __webpack_public_path__ + "static/media/harvard-wide.0b0885c8.png";